import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('auth_token') || '');

  const checkAuth = useCallback(async () => {
    try {
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      const resp = await axios.get(`${API}/auth/me`, {
        withCredentials: true,
        headers,
      });
      setUser(resp.data);
    } catch {
      setUser(null);
      setToken('');
      localStorage.removeItem('auth_token');
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const resp = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
    const data = resp.data;
    setUser(data);
    if (data.token) {
      setToken(data.token);
      localStorage.setItem('auth_token', data.token);
    }
    return data;
  };

  const register = async (name, email, password) => {
    const resp = await axios.post(`${API}/auth/register`, { name, email, password }, { withCredentials: true });
    const data = resp.data;
    setUser(data);
    if (data.token) {
      setToken(data.token);
      localStorage.setItem('auth_token', data.token);
    }
    return data;
  };


  const logout = async () => {
    try {
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true, headers });
    } catch {}
    setUser(null);
    setToken('');
    localStorage.removeItem('auth_token');
  };

  const authHeaders = () => {
    const h = {};
    if (token) h.Authorization = `Bearer ${token}`;
    return h;
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, register, logout, token, authHeaders }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}

export default AuthContext;
